
<v-dialog v-model="dialog" :max-width="$vuetify.breakpoint.mobile ? '100%' : '30%'" persistent>
	<v-card class="justify-center text-center card-rounded pb-5">
		<v-card-title class="pa-2 white--text justify-center text-center accent">
			<v-spacer />
			Chat with {{ this.receiverData.name }}
			<v-spacer />
			<v-icon icon @click="GetConversationMessages">mdi-refresh</v-icon>
			<v-icon icon @click="close">mdi-close</v-icon>
		</v-card-title>
		<div ref="messageContainer" :style="'max-height:' + ($vuetify.breakpoint.mobile ? '425px' : '500px')" class="scrollable-card-text">
			<div v-for="message in messages" :key="message.id">
				<v-card-text>
					<v-row :justify="message.sentByID === receiverData.id ? 'start' : 'end'">
						<v-col md="8">
							<v-card
								:class="message.sentByID === receiverData.id ? 'text-left rounded-r-xl' : 'text-left rounded-l-xl'"
								style="color: white"
								:color="message.sentByID === receiverData.id ? 'green' : 'accent'"
							>
								<v-row>
									<v-col :cols="message.sentByID === receiverData.id ? '11' : '10'" style="margin-left: 1rem">
										<div justify="left" :class="'white--text'">{{ message.message }}</div>
									</v-col>
									<v-col v-if="message.sentByID !== receiverData.id" cols="1">
										<div class="d-flex align-end justify-end" style="height: 100%">
											<img v-if="message.isSeen === true" class="white--text align-end" height="16" :src="require('../../assets/icons/read_ticks.svg')" />
											<img
												v-else-if="message.isSeen === false"
												class="white--text align-end"
												height="15"
												:src="require('../../assets/icons/unread_ticks.svg')"
											/>
										</div>
									</v-col>
								</v-row>
							</v-card>
						</v-col>
					</v-row>
				</v-card-text>
				<!-- <v-card-text> -->
				<v-card-text :style="(message.sentByID === receiverData.id ? 'text-align: left' : 'text-align: right') + '; padding-top:0.1rem; padding-bottom: 1rem;'">{{
					formatMessageDateTime(message.createdAt)
				}}</v-card-text>
				<!-- </v-card-text> -->
			</div>
		</div>
		<v-card-actions>
			<div style="display: flex; flex-direction: row; width: 100%">
				<div style="flex-basis: 90%; margin-left: 1rem">
					<v-text-field
						v-model="sendMessage"
						placeholder="Type a message..."
						color="green"
						class="pa-4 bg-green rounded-s-xl rounded-e-xl"
						style="background-color: #f5f5f5; border-radius: 10px"
						@keyup.enter="onSend()"
					></v-text-field>
				</div>
				<div style="flex-basis: 10%; display: flex; justify-content: center; align-items: center">
					<v-btn :disabled="sendMessage === null || sendMessage.match(/^ *$/) !== null" class="mx-2" fab color="accent" size="small" @click="SendMessage"
						><v-icon>mdi-send</v-icon>
					</v-btn>
				</div>
			</div>
		</v-card-actions>
	</v-card>
</v-dialog>
